export enum ApplicationEnvironments {
  Development = 'Development',
  Testing = 'Testing',
  Production = 'Production',
}
